import apiClient from './api';
import { Subscription } from '../types/subscription'; // تأكد من وجود هذا النوع
import {  SubscriptionStatus, PaymentStatus } from '../types/enums'
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لإنشاء اشتراك جديد
export interface NewSubscriptionData {
  lawyer_id: number;
  start_date: string;
  end_date: string;
  fee: number;
  payment_status: PaymentStatus;
}

// نوع بيانات لتحديث اشتراك
export interface UpdateSubscriptionData {
  start_date?: string;
  end_date?: string;
  fee?: number;
  payment_status?: PaymentStatus;
  status?: SubscriptionStatus;
}


export interface SubscriptionSelectionData {
  id: number;
  fee: number;
  displayText: string;
}

/**
 * جلب قائمة الاشتراكات للاختيار
 */
export const getSubscriptionsForSelection = async (): Promise<SubscriptionSelectionData[]> => {
  const response = await apiClient.get<{ data: SubscriptionSelectionData[] }>('/subscriptions/for-selection');
  return response.data.data;
};
/**
 * جلب قائمة الاشتراكات مع دعم للترقيم والبحث والفرز
 */
export const getPagedSubscriptions = async (params: TableParams): Promise<PagedResult<Subscription>> => {
  const response = await apiClient.get<{ data: PagedResult<Subscription> }>('/subscriptions/paged', { params });
  return response.data.data;
};

/**
 * جلب اشتراك بواسطة ID
 */
export const getSubscriptionById = async (id: number): Promise<Subscription> => {
  const response = await apiClient.get<{ data: Subscription }>(`/subscriptions/${id}`);
  return response.data.data;
};

/**
 * إنشاء اشتراك جديد
 */
export const createSubscription = async (subscriptionData: NewSubscriptionData): Promise<Subscription> => {
  const response = await apiClient.post<{ data: Subscription }>('/subscriptions', subscriptionData);
  return response.data.data;
};

/**
 * تحديث اشتراك موجود
 */
export const updateSubscription = async (id: number, subscriptionData: UpdateSubscriptionData): Promise<Subscription> => {
  const response = await apiClient.put<{ data: Subscription }>(`/subscriptions/${id}`, subscriptionData);
  return response.data.data;
};

/**
 * حذف اشتراك بواسطة ID
 */
export const deleteSubscription = async (id: number): Promise<void> => {
  await apiClient.delete(`/subscriptions/${id}`);
};


export const renewMySubscription = async (): Promise<Subscription> => {
  // (1) !! استدعاء نقطة النهاية الجديدة التي أنشأناها في الخادم !!
  const response = await apiClient.post<{ data: Subscription }>(
    '/subscriptions/my-subscription/renew'
  );
  
  // (2) !! إعادة البيانات من الاستجابة !!
  return response.data.data;
};


/**
 * [LAWYER] جلب الاشتراك الحالي أو الأخير للمستخدم (المحامي)
 */
export const getMySubscription = async (): Promise<Subscription | null> => {
  const response = await apiClient.get<{ data: Subscription | null }>('/subscriptions/my-subscription');
  return response.data.data;
};

